import { all } from 'redux-saga/effects';

import authSagas from './auth';
import appSagas from './app';
import segmentsListSagas from './segments_list';
import segmentsViewSagas from './segments_view';
import segmentsCompareSagas from './segments_compare';
import clusterSagas from './clusters';
import modelsListSagas from './models_list';
import modelViewSagas from './model_view';
import modelAddSagas from './model_add';
import modelsCompareSagas from './models_compare';
import onboardingSagas from './onboarding';
import usersSagas from './users';
import usersEditSagas from './users_edit';
import rtApiListSagas from './rt_api_list';
import rtApiDemoSagas from './rt_api_demo';
import rtApiUsageSagas from './rt_api_usage';
import copyPxSagas from './copy_px';
import clientsEditSagas from './clients_edit';

export default function* generators() {
  yield all([
    ...authSagas,
    ...appSagas,
    ...segmentsListSagas,
    ...segmentsViewSagas,
    ...segmentsCompareSagas,
    ...clusterSagas,
    ...modelsListSagas,
    ...modelViewSagas,
    ...modelAddSagas,
    ...modelsCompareSagas,
    ...onboardingSagas,
    ...usersSagas,
    ...usersEditSagas,
    ...rtApiListSagas,
    ...rtApiDemoSagas,
    ...rtApiUsageSagas,
    ...copyPxSagas,
    ...clientsEditSagas,
  ]);
}
